import React from 'react';
import { Button, Icon, Modal } from 'lmc-ui-library';
import { ErrorItem, ErrorText } from './ValidationErrorModal.styled';

const getErrorsFromError = (error: any): string[] => {
  let errors: any = [];

  if (!error) {
    return [];
  }

  if (error.response) {
    if (error.response.status === 400 && error.response.data.errorCode === 'COVERAGE_ISSUE') {
      const duplicated = [...error.response.data.duplicatedClubs, ...error.response.data.duplicatedNetworks];
      const notCovered = [...error.response.data.notCoveredClubs, ...error.response.data.notCoveredNetworks];

      if (duplicated.length) {
        errors = [
          ...errors,
          `The following clubs/networks have more than one standard commission term assigned to a product. Please resolve:\n- ${duplicated.join(
            ',\n- ',
          )}`,
        ];
      }

      if (notCovered.length) {
        errors = [
          ...errors,
          `The following clubs/networks have products that are not covered by a Standard Commission Term. Please resolve:\n- ${notCovered.join(
            ',\n- ',
          )}`,
        ];
      }
    } else {
      errors = [...errors, `An unexpected error occurred (${error.response.status})`];
    }
  } else {
    errors = [error.toString()];
  }
  return errors;
};

const ValidationErrorModal: React.FC<any> = ({ error, onCloseButtonClick, onUpdateAnyway }) => {
  return (
    <Modal showCloseBtn={false} isOpen={error} style={{ width: '600px', height: '600px' }}>
      <Modal.Header title="Error!" mode="error" />
      <Modal.Content>
        {getErrorsFromError(error).map((err, index) => (
          <ErrorItem key={index}>
            <Icon type="warning" color="#FA5245" />
            <ErrorText>{err}</ErrorText>
          </ErrorItem>
        ))}
      </Modal.Content>
      <Modal.Footer style={{ display: 'grid' }}>
        <Button mode="ghost" borderVariant="rectangle" onClick={onUpdateAnyway}>
          Update anyway
        </Button>
        <br />
        <Button mode="normal" borderVariant="rectangle" onClick={onCloseButtonClick} style={{ color: 'red' }}>
          Cancel changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ValidationErrorModal;
